
import React from 'react';
import './Loading.css'; 

//loading bar that displays on any page loading
const Loading = (position) => {
  return (
        <div className="loader" style={{position: position}}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
          <div className="bar4"></div>
          <div className="bar5"></div>
          <div className="bar6"></div>
        </div>
    );
};

export default Loading;